module.exports = __webpack_public_path__ + "img/image2.48176beb.png";